"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class Plan extends Parse.Object {
    constructor(attributes) {
        super('Plan', attributes);
    }
    get name() { return this.get('name'); }
    set name(value) { this.set('name', value); }
    get enabled() { return this.get('enabled'); }
    set enabled(value) { this.set('enabled', value); }
    get basePrice() { return this.get('basePrice'); }
    set basePrice(value) { this.set('basePrice', value); }
    get billingPeriod() { return this.get('billingPeriod'); }
    set billingPeriod(value) { this.set('billingPeriod', value); }
    get key() { return this.get('key'); }
    set key(value) { this.set('key', value); }
    // The season this plan was created (ex: 3Q-2020)
    // we use this to differentiate betweens plans with same name but different values for our customer
    get season() { return this.get('season'); }
    set season(value) { this.set('season', value); }
}
exports.Plan = Plan;
Parse.Object.registerSubclass('Plan', Plan);
//# sourceMappingURL=Plan.js.map